import http from '@/utils/http';

export default {
	list: data => {
		return http({url:'/api/admin/v1/roles/list',data}).then(r => r)
	},
	save: data => {
		return http({url:'/api/admin/v1/roles/save',data,tip:true,loading:true}).then(r => r)
	},
	delete: data => {
		return http({url:'/api/admin/v1/roles/delete',data,tip:true,loading:true}).then(r => r)
	},
	getAll: () => {
		return http({url:'/api/admin/v1/roles/getAll'}).then(r => r)
	}
}